import { Modal, ModalHeader, ModalBody } from 'reactstrap';
import {
  ButtonColors,
  ButtonSizes,
  ButtonVariants,
  LinkButton,
} from 'components';
import { useAnalytics } from 'contexts/analytics/AnalyticsProvider';
import { AddPractitionerForm } from './AddPractitionerForm';
import TinyAccount from 'types/TinyAccount';

import styles from './AccountModal.module.css';

type AddPractitionerModalProps = {
  tinyAccount: TinyAccount;
  toggle: () => void;
  showModal: boolean;
};

const AddPractitionerModal = ({
  tinyAccount,
  toggle,
  showModal,
}: AddPractitionerModalProps) => {
  const { trackEvent } = useAnalytics();
  return (
    <>
      <Modal
        isOpen={showModal}
        toggle={toggle}
        fullscreen='md'
        className={styles.modalContainer}
      >
        <ModalHeader toggle={toggle} className={styles.modalHeader}>
          Practitioner
        </ModalHeader>
        <ModalBody className={styles.modalBody}>
          <AddPractitionerForm
            tinyAccount={tinyAccount}
            practitionerId={tinyAccount?.practitioner_id}
            onFinishCallback={() => {
              trackEvent('Practitioner Added');
              toggle();
            }}
          />
          <span className={styles.modalFooter}>
            {`Don't see your practitioner on the list? Have them contact us at `}
          </span>
          <LinkButton
            label='practitioners@tinyhealth.com'
            href={'mailto:practitioners@tinyhealth.com'}
            external
            variant={ButtonVariants.TEXT}
            size={ButtonSizes.M}
            color={ButtonColors.PURPLE}
          />
        </ModalBody>
      </Modal>
    </>
  );
};
export default AddPractitionerModal;
